import React, { FC } from 'react';
import { SelectProps } from 'antd';
import { useAgents } from '~/controllers/agent';
import Select from './Select';

const AssigneeSelect: FC<SelectProps<string>> = (props) => {
  const agents = useAgents();
  const options = agents.data?.map(({ id, fullName }) => ({
    label: fullName,
    value: id,
    key: id,
  }));

  return <Select loading={agents.isLoading} disabled={agents.isLoading} showSearch options={options} {...props} />;
};

export default AssigneeSelect;
